import { useGlobalContext } from '@/context/Global/GlobalContext';
import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import { MainLayout } from '@/layouts/MainLayout/MainLayout';
import { DashboardUserType } from '@/utils/enums';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export const SellerPrivate = () => {
  const { session } = useGlobalContext();
  const navigate = useNavigate();
  const { showSnackError } = useSnackbarContext();

  useEffect(() => {
    if (session === undefined) return; // retreiving session
    if (session?.type !== DashboardUserType.SELLER) {
      showSnackError('¡No autorizado! Su sesión podría haber expirado', 5000);
      navigate('/seller/login');
    }
  }, [session]);

  if (session?.type === DashboardUserType.SELLER) {
    return (
      <MainLayout>
        <Outlet />
      </MainLayout>
    );
  }
};
